module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/course/labs/awsop/awsop-labs-nav/awsop-labs-nav.component.css
// module id = ./src/app/course/labs/awsop/awsop-labs-nav/awsop-labs-nav.component.css
// module chunks = main